var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 11C23.0883 11 11 23.0883 11 38C11 52.9117 23.0883 65 38 65C52.9117 65 65 52.9117 65 38C65 23.0883 52.9117 11 38 11ZM5 38C5 19.7746 19.7746 5 38 5C56.2254 5 71 19.7746 71 38C71 56.2254 56.2254 71 38 71C19.7746 71 5 56.2254 5 38Z",
    fill: "#618DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 20C35 18.3431 36.3431 17 38 17C49.598 17 59 26.402 59 38C59 39.6569 57.6569 41 56 41C54.3431 41 53 39.6569 53 38C53 29.7157 46.2843 23 38 23C36.3431 23 35 21.6569 35 20Z",
    fill: "#618DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8787 57.8787C59.0503 56.7071 60.9497 56.7071 62.1213 57.8787L74.1213 69.8787C75.2929 71.0503 75.2929 72.9497 74.1213 74.1213C72.9497 75.2929 71.0503 75.2929 69.8787 74.1213L57.8787 62.1213C56.7071 60.9497 56.7071 59.0503 57.8787 57.8787Z",
    fill: "#618DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-Search.42bd5d2073c19ed17ab13cbcc0286770.svg";
export { ForwardRef as ReactComponent };